export type DashboardSection =
  | 'godHeader'
  | 'platformStats'
  | 'statsGrid'
  | 'opsAlerts'
  | 'godAnalytics'
  | 'periodReports'
  | 'trendCharts'
  | 'recentActivity'
  | 'quickLinks'
  | 'roleWidgets'
  | 'partnerGuide';

export interface DashboardRoleConfig {
  label: string;
  subtitle: string;
  eyebrow: string;
  sections: DashboardSection[];
  showFullGodView: boolean;
}

export const DASHBOARD_ROLE_CONFIG: Record<string, DashboardRoleConfig> = {
  super_admin: {
    label: 'Dashboard',
    eyebrow: 'Super Admin',
    subtitle: 'Cross-tenant command center — live volume, revenue, tenants, and operational health.',
    sections: ['godHeader', 'platformStats', 'statsGrid', 'opsAlerts', 'godAnalytics', 'periodReports', 'recentActivity', 'quickLinks'],
    showFullGodView: true,
  },
  client_admin: {
    label: 'Dashboard',
    eyebrow: 'Client Admin',
    subtitle: 'Real-time pulse across transport, delivery, on-demand, and events — revenue, completion, and live jobs.',
    sections: ['godHeader', 'statsGrid', 'opsAlerts', 'godAnalytics', 'periodReports', 'trendCharts', 'recentActivity', 'quickLinks'],
    showFullGodView: true,
  },
  employee: {
    label: 'Ops Command Center',
    eyebrow: 'Staff',
    subtitle: 'Monitor pending jobs, active deliveries, settlements, and service performance.',
    sections: ['godHeader', 'statsGrid', 'opsAlerts', 'godAnalytics', 'periodReports', 'recentActivity', 'quickLinks'],
    showFullGodView: true,
  },
  driver: {
    label: 'Driver Hub',
    eyebrow: 'Driver',
    subtitle: 'Your rides, earnings context, and live transport activity.',
    sections: ['godHeader', 'roleWidgets', 'trendCharts', 'recentActivity'],
    showFullGodView: false,
  },
  delivery_partner: {
    label: 'Delivery Hub',
    eyebrow: 'Delivery Partner',
    subtitle: 'Food and grocery queue, deliveries, and earnings overview.',
    sections: ['partnerGuide', 'godHeader', 'roleWidgets', 'trendCharts', 'recentActivity'],
    showFullGodView: false,
  },
  merchant: {
    label: 'Vendor Hub',
    eyebrow: 'Vendor',
    subtitle: 'Food & grocery orders, menu, inventory, promos, and store performance.',
    sections: ['godHeader', 'roleWidgets', 'trendCharts', 'recentActivity'],
    showFullGodView: false,
  },
  service_provider: {
    label: 'Provider Hub',
    eyebrow: 'Service Provider',
    subtitle: 'Bookings, completion rate, and recent on-demand activity.',
    sections: ['godHeader', 'roleWidgets', 'recentActivity'],
    showFullGodView: false,
  },
  vendor: {
    label: 'Vendor Hub',
    eyebrow: 'Vendor',
    subtitle: 'Food & grocery orders, menu, inventory, and store performance.',
    sections: ['godHeader', 'roleWidgets', 'trendCharts', 'recentActivity'],
    showFullGodView: false,
  },
  customer: {
    label: 'My Dashboard',
    eyebrow: 'Customer',
    subtitle: 'Your recent orders and bookings.',
    sections: ['godHeader', 'recentActivity'],
    showFullGodView: false,
  },
};

export function getDashboardRoleConfig(userType?: string): DashboardRoleConfig {
  return DASHBOARD_ROLE_CONFIG[userType || 'client_admin'] || DASHBOARD_ROLE_CONFIG.client_admin;
}

export function hasSection(config: DashboardRoleConfig, section: DashboardSection): boolean {
  return config.sections.includes(section);
}
